import { IconComponentProps } from '../IconTypes';

const PriorityFlag = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 25 24" width="25" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.8335 3.25C5.8335 2.55859 5.2749 2 4.5835 2C3.89209 2 3.3335 2.55859 3.3335 3.25V4.5V16.375V20.75C3.3335 21.4414 3.89209 22 4.5835 22C5.2749 22 5.8335 21.4414 5.8335 20.75V15.75L8.34521 15.1211C9.95068 14.7188 11.6499 14.9062 13.1304 15.6445C14.8569 16.5078 16.8608 16.6133 18.6655 15.9336L20.021 15.4258C20.5093 15.2422 20.8335 14.7773 20.8335 14.2539V4.58203C20.8335 3.68359 19.8882 3.09766 19.0835 3.5L18.7085 3.6875C16.8999 4.59375 14.771 4.59375 12.9624 3.6875C11.5913 3 10.0171 2.82812 8.52881 3.19922L5.8335 3.875V3.25Z"
      fill="currentColor"
    />
  </svg>
);

export default PriorityFlag;
